import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'email_status',
})
export class EmailStatusFilterPipe implements PipeTransform {
    transform(status: number) {
        if (status == 0) {
            return 'Delivered'
        } else if (status == 1) {
            return 'Viewed'
        } else if (status == 2) {
            return 'Files Downloaded'
        } else if (status == 3) {
            return 'Files Signed'
        }
        return status
    }
}
